<div [appStoryblok]="_editable">
  <div class="container-xl">
    <div class="row">
      <div class="col-md-3">
        <div class="shop-by-title">{{ title }}</div>
        <div
          class="slide-title my-2 action"
          [ngClass]="{ active: _selected === slide }"
          (mouseenter)="onSlideEnter(slide, $event)"
          (click)="navigate(slide.link)"
          *ngFor="let slide of slides"
        >
          {{ slide.title }}
          <svg
            class="stroke"
            width="79"
            height="7"
            viewBox="0 0 79 7"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M77.0909 4.07889C56.2489 2.64882 28.7216 3.62131 2.62819 6.28022C-0.89466 6.55792 -1.40591 3.8714 5.98376 3.17867C30.9719 0.836226 57.185 0.00482993 77.037 1.36739C78.0265 1.45699 78.7558 1.98058 78.6845 3.03369C78.6131 4.0868 78.0801 4.1652 77.0909 4.07889Z"
              fill="#FFAEDF"
            />
          </svg>
        </div>
      </div>
      <div
        class="d-none d-md-flex col-md-8 offset-md-1 image-container position-relative"
      >
        <img
          width="745"
          height="435"
          class="spacer w-100"
          sizes="50vw"
          [ngSrc]="slides[0]?.image?.filename"
          *ngIf="slides[0]?.image?.filename"
        />
        <ng-container *ngFor="let entry of slides; let index = index">
          <img
            width="745"
            height="435"
            class="backdrop w-100"
            [ngClass]="[_selected === entry ? 'fade-in' : 'fade-out']"
            [ngSrc]="entry?.image?.filename"
            sizes="50vw"
            *ngIf="entry?.image?.filename"
          />
          <div
            class="content"
            [ngClass]="[_selected === entry ? 'fade-in' : 'fade-out']"
          >
            <div class="rich" [storyblokRichText]="entry.content"></div>
            <a [storyblokLink]="entry.link" class="btn btn-secondary"
              >Shop Now</a
            >
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  @defer {

  <img
    cover
    [ngSrc]="background.filename"
    priority
    width="1439"
    height="726"
    class="bg"
    *ngIf="background.filename"
  />
  } @placeholder {
  <div class="bg-secondary"></div>
  }
</div>
